import { NavigationConstants } from '../constants/actions';

export {
  goToPage,
  replacePage,
  goToReturnPage,
  saveLocationHistory
} from '@epi-store/navigation/navigation.slice';

export const openPageEventStart = path => ({
  type: NavigationConstants.OPEN_PAGE_EVENT_START,
  path
});

export const openPageEventEnd = path => ({
  type: NavigationConstants.OPEN_PAGE_EVENT_END,
  path
});
